import { call, put, takeLatest } from 'redux-saga/effects';
import { dealerDailyCdpSyncSettingsActions } from './slice';
import {
  fetchDealerDailyCdpSyncSettings,
  updateDealerDailyCdpSyncSettings,
} from './data/dealerDailyCdpSyncSettingsDataService';
import { notificationAlertActions } from 'app/pages/NotificationAlert/slice';

function* fetchDealerDailyCdpSyncSettingsSaga(action: ReturnType<any>) {
  try {
    const response = yield call(fetchDealerDailyCdpSyncSettings, {
      dealershipId: action.payload.dealershipId,
    });
    yield put(
      dealerDailyCdpSyncSettingsActions.requestDealerDailyCdpSyncSettingsSuccess(
        response,
      ),
    );
  } catch (error: any) {
    yield put(
      dealerDailyCdpSyncSettingsActions.requestDealerDailyCdpSyncSettingsError(
        error.message,
      ),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Dealer daily CDP sync settings fetch failed',
      }),
    );
  }
}

function* updateDealerDailyCdpSyncSettingsSaga(action: ReturnType<any>) {
  const dealershipId = action.payload.dealershipId;
  try {
    yield call(updateDealerDailyCdpSyncSettings, {
      dealershipId,
      data: action.payload.data,
      settingsId: action.payload.settingsId,
    });
    yield put(
      dealerDailyCdpSyncSettingsActions.requestUpdateDealerDailyCdpSyncSettingsSuccess(),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: 'Dealer daily CDP sync settings saved',
      }),
    );
    yield put(
      dealerDailyCdpSyncSettingsActions.requestDealerDailyCdpSyncSettings({
        dealershipId,
      }),
    );
  } catch (error: any) {
    yield put(
      dealerDailyCdpSyncSettingsActions.requestUpdateDealerDailyCdpSyncSettingsError(
        error.message,
      ),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Dealer daily CDP sync settings save failed',
      }),
    );
    yield put(
      dealerDailyCdpSyncSettingsActions.requestDealerDailyCdpSyncSettings({
        dealershipId,
      }),
    );
  }
}

export function* watchDealerDailyCdpSyncSettingsSaga() {
  yield takeLatest(
    dealerDailyCdpSyncSettingsActions.requestDealerDailyCdpSyncSettings.type,
    fetchDealerDailyCdpSyncSettingsSaga,
  );
  yield takeLatest(
    dealerDailyCdpSyncSettingsActions.requestUpdateDealerDailyCdpSyncSettings
      .type,
    updateDealerDailyCdpSyncSettingsSaga,
  );
}
